import { ITextFieldProps } from 'src/components/TextField/types';

export type SearchInputProps = {
  onSearch(query: string): void;
  placeholder?: string;
  width?: number | string;
  value?: string;
} & Pick<ITextFieldProps, 'sx' | 'style' | 'label'>;

export const TEST_ID = 'IcSearch' as const;
